import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Anomaly Type',
    name: 'Anomaly Type',
    partialId: PartialId.Standard.create('anomaly_type'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
